import {Outlet, useLocation} from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";
import { inject, observer } from "mobx-react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import NavbarItem from "../navbar-item";
import "./admin-navigation-bar.css";
import AccessControl from "../../utils/access_control";
import {ADMIN_SECTION_DEFINITIONS} from "../../utils/admin-sections";

const AdminNavigationBar = inject("data")(observer(({data}) => {
    const location = useLocation();
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);
    const navTabsRef = useRef(null);

    const checkScrollButtons = () => {
        if (navTabsRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = navTabsRef.current;
            setCanScrollLeft(scrollLeft > 0);
            setCanScrollRight(scrollLeft < scrollWidth - clientWidth);
        }
    };

    const scrollLeft = () => {
        if (navTabsRef.current) {
            navTabsRef.current.scrollBy({ left: -200, behavior: 'smooth' });
        }
    };

    const scrollRight = () => {
        if (navTabsRef.current) {
            navTabsRef.current.scrollBy({ left: 200, behavior: 'smooth' });
        }
    };

    useEffect(() => {
        checkScrollButtons();
        const navTabs = navTabsRef.current;
        if (navTabs) {
            navTabs.addEventListener('scroll', checkScrollButtons);
            window.addEventListener('resize', checkScrollButtons);
        }
        return () => {
            if (navTabs) {
                navTabs.removeEventListener('scroll', checkScrollButtons);
                window.removeEventListener('resize', checkScrollButtons);
            }
        };
    }, []);

    return <div className="card pl-4 pr-4 pb-3 rounded-lg">
            <div className="navbar mb-4">
                <div className="nav-container">
                    {canScrollLeft && (
                        <div 
                            className="nav-arrow nav-arrow-left pointer icon-box" 
                            onClick={scrollLeft}
                            aria-label="Scroll left"
                        >
                            <FontAwesomeIcon icon={faAngleLeft} className="fa-2x pointer text-primary" />
                        </div>
                    )}
                    <div className="d-flex nav-tabs ml-4" ref={navTabsRef}>
                        {ADMIN_SECTION_DEFINITIONS.map((section) => (
                            <NavbarItem
                                key={section.key}
                                path={section.path}
                                currentPath={location.pathname}
                                translationKey={section.translationKey}
                                hasAccess={AccessControl.canAccessAdminSection(data, section.key)}
                                showBorder={section.key !== "clients"}
                            />
                        ))}
                    </div>
                    {canScrollRight && (
                        <div 
                            className="nav-arrow nav-arrow-right pointer icon-box" 
                            onClick={scrollRight}
                            aria-label="Scroll right"
                        >
                            <FontAwesomeIcon icon={faAngleRight} className="fa-2x pointer text-primary" />
                        </div>
                    )}
                </div>
            </div>
            <Outlet/>
        </div>
}));

export default AdminNavigationBar;
